// extracted by mini-css-extract-plugin
export default {"terms_nav":"TermsNav_terms_nav__a3vBz","termsnav_active":"TermsNav_termsnav_active__UnJyS"};